import { Box, Card, Skeleton } from '@sbv-clients/ui-shared';

import { useCardSx } from './use-card-sx';

export const DashboardSkeleton = () => {
  const cardSx = useCardSx();
  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '5fr 7fr' },
          gap: 4,
          mb: 4,
        }}
      >
        <Card sx={cardSx} elevation={0}>
          <Skeleton width={80} height={16} />
          <Skeleton width={60} height={48} sx={{ my: 1 }} />
          <Skeleton width="100%" height={36} />
        </Card>
        <Card sx={{ ...cardSx, pb: 0 }} elevation={0}>
          <Skeleton width={120} height={16} />
          <Skeleton width="100%" height={60} sx={{ mt: 2 }} />
          <Skeleton width="100%" height={60} />
        </Card>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' },
          gap: 4,
          mb: 4,
        }}
      >
        {[0, 1, 2].map((i) => (
          <Card key={i} sx={{ ...cardSx, pb: 3 }} elevation={0}>
            <Skeleton width={80} height={16} />
            <Skeleton width={60} height={48} sx={{ my: 2 }} />
            <Skeleton width="100%" height={24} />
          </Card>
        ))}
      </Box>
      <Card sx={cardSx} elevation={0}>
        <Skeleton width={160} height={16} />
        {[0, 1, 2, 3].map((i) => (
          <Skeleton key={i} width="100%" height={56} sx={{ mt: 1 }} />
        ))}
      </Card>
    </>
  );
};
